import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import styles from './CountDown.module.css';

const CountDown = ({ is_active, code, position, color, now, started_at, ended_at, onTimeUp }) => {
  CountDown.protoTypes = {
    now: PropTypes.string.isRequired,
    started_at: PropTypes.string,
    ended_at: PropTypes.string,
    code: PropTypes.number,
    position: PropTypes.string,
    color: PropTypes.string,
    onTimeUp: PropTypes.func,
    className: PropTypes.string
  };

  const calculateTimeLeft = () => {
    const currentTime = now !== null ? new Date().getTime() : new Date().getTime();
    const startTime = started_at !== null ? new Date(started_at).getTime() : new Date().getTime();
    const endTime = ended_at !== null ? new Date(ended_at).getTime() : new Date().getTime();

    let difference;

    if (currentTime < startTime) {
      difference = 0;
    } else if (currentTime < endTime) {
      difference = endTime - currentTime;
    } else {
      difference = 0;
    }
    let timeLeft = {
      days: Number(0).toString().padStart(2, '0'),
      hours: Number(0).toString().padStart(2, '0'),
      minutes: Number(0).toString().padStart(2, '0'),
      seconds: Number(0).toString().padStart(2, '0'),
      daysInhours: Number(0).toString().padStart(2, '0')
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60)
          .toString()
          .padStart(2, '0'),
        seconds: Math.floor((difference / 1000) % 60)
          .toString()
          .padStart(2, '0'),
        daysInhours:
          Math.floor(difference / (1000 * 60 * 60 * 24)) * 24 + timeLeft.hours < 10
            ? (
                Math.floor(difference / (1000 * 60 * 60 * 24)) * 24 +
                Math.floor((difference / (1000 * 60 * 60)) % 24)
              )
                .toString()
                .padStart(2, '0')
            : (
                Math.floor(difference / (1000 * 60 * 60 * 24)) * 24 +
                Math.floor((difference / (1000 * 60 * 60)) % 24)
              ).toString()
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    let timer;
    if (Number(timeLeft.daysInhours) <= 99) {
      timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);
    }
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    if (isEmpty(timeLeft)) {
      if (onTimeUp) onTimeUp();
    }
  }, [timeLeft, is_active, code, position, color, now, started_at, ended_at, onTimeUp]);

  // function that makes you color darker or lighter
  const adjustColorBrightness = (color2, value) => {
    // Ensure that the value is between -100 and 100
    value = Math.max(-100, Math.min(100, value));
    const hex = color2.replace(/^#/, '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const adjust = (c) => {
      const adjusted = c + (c * value) / 100;
      return Math.min(255, Math.max(0, adjusted));
    };
    const adjustedR = adjust(r);
    const adjustedG = adjust(g);
    const adjustedB = adjust(b);
    const resultColor = `#${Math.round(adjustedR).toString(16).padStart(2, '0')}${Math.round(
      adjustedG
    )
      .toString(16)
      .padStart(2, '0')}${Math.round(adjustedB).toString(16).padStart(2, '0')}`;

    return resultColor;
  };

  const generateColorStyle = () => {
    const style = {
      backgroundColor: color
    };
    return style;
  };

  const adjustedColor = adjustColorBrightness(color, -40);

  const dynamicClass1 = `ContentItem-${code}-${position}`;
  const dynamicClass2 = `Title-${code}`;
  const dynamicClass3 = `NumberContainer-${code}`;
  const dynamicClass4 = `DoubleDot-${code}`;
  const dynamicClass5 = `TitleAfter-${code}-${position}`;

  return code == null ||
    color === null ||
    started_at === null ||
    ended_at === null ||
    position === null ||
    now === null ? null : is_active === true ? (
    <div className={styles.HelbestCountdownContainer}>
      <div
        className={`${styles.ContentItem} ${styles[dynamicClass1]}`}
        style={generateColorStyle()}>
        <span className={`${styles[dynamicClass2]}`}>
          <span
            className={`${styles[dynamicClass3]}`}
            style={{ color: code === 2 ? color : 'white' }}>
            {' '}
            {timeLeft.daysInhours > 99 ? 59 : timeLeft.seconds}{' '}
          </span>
          <span className={`${styles[dynamicClass4]}`}> : </span>
          <span
            className={`${styles[dynamicClass3]}`}
            style={{ color: code === 2 ? color : 'white' }}>
            {' '}
            {timeLeft.daysInhours > 99 ? 59 : timeLeft.minutes}{' '}
          </span>
          <span className={`${styles[dynamicClass4]}`}> : </span>
          <span
            className={`${styles[dynamicClass3]}`}
            style={{ color: code === 2 ? color : 'white' }}>
            {' '}
            {timeLeft.daysInhours > 100 ? 99 : timeLeft.daysInhours}{' '}
          </span>
        </span>
        <div
          className={`${styles.TitleAfter} ${styles[dynamicClass5]} `}
          style={{ backgroundColor: adjustedColor }}
        />
        <div
          className={`${styles.TitleAfter} ${styles[dynamicClass5]} `}
          style={{ backgroundColor: adjustedColor }}
        />
      </div>
    </div>
  ) : null;
};

export default CountDown;
